import { render, staticRenderFns } from "./department.vue?vue&type=template&id=5ea1c334&scoped=true"
import script from "./department.vue?vue&type=script&lang=js"
export * from "./department.vue?vue&type=script&lang=js"
import style0 from "./department.vue?vue&type=style&index=0&id=5ea1c334&prod&lang=css"
import style1 from "./department.vue?vue&type=style&index=1&id=5ea1c334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea1c334",
  null
  
)

export default component.exports